import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/auth/PrivateRoute';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Signup from './pages/Signup';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import Templates from './pages/Templates';
import Channels from './pages/Channels';
import LeadSources from './pages/LeadSources';
import Settings from './pages/Settings';
import Billing from './pages/Billing';
import Help from './pages/Help';
import Notifications from './pages/Notifications';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DataDeletion from './pages/DataDeletion';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

import './App.css';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ThemeProvider>
        <AuthProvider>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/register" element={<Navigate to="/signup" replace />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/data-deletion" element={<DataDeletion />} />

              {/* Protected Routes — wrapped in Layout */}
              <Route
                path="/*"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Routes>
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="leads" element={<Leads />} />
                        <Route path="leads/:id" element={<LeadDetail />} />
                        <Route path="templates" element={<Templates />} />
                        <Route path="channels" element={<Channels />} />
                        <Route path="lead-sources" element={<LeadSources />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="billing" element={<Billing />} />
                        <Route path="help" element={<Help />} />
                        <Route path="notifications" element={<Notifications />} />
                        <Route path="admin" element={<AdminDashboard />} />
                        {/* Messages and Calendar are disabled in Sidebar, but good to have routes just in case or for future */}
                        <Route path="messages" element={<Navigate to="/dashboard" replace />} />
                        <Route path="calendar" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                      </Routes>
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
